
import logoHrBlue from './../assets/images/latribu-hr-blue.svg'


import pencho from './../assets/images/team/pencho.jpeg'
import chino from './../assets/images/team/chino.jpeg'
import karen from './../assets/images/team/karen.jpeg'
import carms from './../assets/images/team/carms.jpeg'
import chomito from './../assets/images/team/chomito.jpeg'
import milo from './../assets/images/team/milo.jpeg'
import angela from './../assets/images/team/angela.jpeg'
import teamjpg from './../assets/images/team/team.jpeg'

const people = [
    {
        name: 'Pencho Duque',
        mail: 'pencho@latribu.fm',
        imageUrl: pencho,
    },
    {
        name: 'Claudio "Chino" Martínez',
        mail: 'chino@latribu.fm',
        imageUrl: chino,
    },
    {
        name: 'Karen Bitton',
        mail: 'karen@latribu.fm',
        imageUrl: karen,
    },
    {
        name: 'Carms Gamero',
        mail: 'carms@latribu.fm',
        imageUrl: carms,
    },
    {
        name: 'Roberto "Chomito" Reyes',
        mail: 'chomito@latribu.fm',
        imageUrl: chomito,
    },
    {
        name: 'Milo Villatoro',
        mail: 'milo@latribu.fm',
        imageUrl: milo,
    },
    {
        name: 'Angela Gutiérrez ',
        mail: 'angela@latribu.fm',
        imageUrl: angela,
    },
   /* {
        name: 'Ochy Salinas',
        role: 'Mercadeo y Comercialización',
        mail: 'ochy@latribu.fm',
        imageUrl: teamOchy,
    },*/
    /*{
        name: 'Beatriz Vásquez',
        role: 'Coordinadora',
        mail: 'beatriz@latribu.fm',
        imageUrl: teamBeatriz,
    },*/
];

export default function MeetTheTeam() {
    return (
        <div id={'meetTheTeam'} className="pe-bg-4">
            <div className="pe-gradient-1">
                <div className="lg:px-8 mx-auto pb-48 px-4 sm:px-6 text-center">
                    <div id={'meetTheTeam'} className="space-y-12 hidden lg:block">
                        <div className="space-y-5 mx-auto sm:space-y-4">
                            <img className="h-56 w-full" src={logoHrBlue} />

                            <ul
                                role="list"
                                className="mx-auto mt-20 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:grid-cols-2 lg:mx-40 lg:max-w-none lg:grid-cols-3"
                            >
                                {people.map((person, index) => (
                                    <li key={person.name} className={index === people.length -1 ? 'lg:col-start-2 lg:col-span-1 md:col-start-1 md:col-span-2' : ''}>
                                        <img
                                            alt=""
                                            src={person.imageUrl}
                                            className="aspect-3/2 w-full rounded-2xl object-cover outline-1 -outline-offset-1 outline-black/5"
                                        />
                                        <h3 className="mt-6 text-lg/8 font-semibold tracking-tight text-gray-900">{person.name}</h3>
                                        <p className="text-base/7 text-gray-600">{person.mail}</p>
                                    </li>
                                ))}
                            </ul>

                        </div>

                    </div>

                    <div className="space-y-12 lg:hidden">
                        <div className="space-y-5 mx-auto sm:space-y-4">
                            <img className="h-56 w-full" src={logoHrBlue} />
                            <ul
                                role="list"
                                className="mx-auto space-y-16 md:grid md:grid-cols-2 md:gap-16 md:space-y-0 lg:grid-cols-3 lg:max-w-5xl"
                            >
                                {people.map((person, index) => (
                                    <li key={person.name} className={index === people.length -1 ? 'lg:col-start-2 lg:col-span-1 md:col-start-1 md:col-span-2' : ''}>
                                        <div className="space-y-6">
                                            <img className="h-96 mx-auto w-auto" src={person.imageUrl} alt="" />
                                            <div className="space-y-2">
                                                <div className="text-lg leading-6 font-medium space-y-1">
                                                    <h3>{person.name}</h3>
                                                    <p className="text-base/7 text-gray-600">{person.mail}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    <div className="flex items-center justify-around mt-10">
                        <img className="h-2/3 w-2/3" src={teamjpg} />
                    </div>

                </div>
            </div>
        </div>
    )
};
